import { formatDateTime } from 'utils/format-date/format-date';

import { DateTimeCellProps } from './types';

export default function DateTimeCell({ date, timezone }: DateTimeCellProps) {
  const [_date, _time] = formatDateTime(date, timezone);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span>{_date}</span>
      <span>{_time}</span>
    </div>
  );
}
